import { create } from 'zustand';

// Which global popups are open. Anything can open them, GameShell renders them.
export const useUI = create((set) => ({
  pricing: null, // { reason } | null
  signup: null, // { reason } | null
  openPricing: (reason) => set({ pricing: { reason } }),
  closePricing: () => set({ pricing: null }),
  openSignup: (reason) => set({ signup: { reason } }),
  closeSignup: () => set({ signup: null }),
}));